import { render, staticRenderFns } from "./BorrarFrecuencia.vue?vue&type=template&id=32315616"
import script from "./BorrarFrecuencia.vue?vue&type=script&lang=js"
export * from "./BorrarFrecuencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports